<template>
    <div>
    <div class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide" :class="{'':!([12,13,14,15,19,22,23,24,26,27,28,29,30].includes(question.response_type))}" v-show="show">
      <div v-if="invalidfield" class="w-full text-red-dark rounded relative px-4 py-2" role="alert">
        <ul class="error-messages block sm:inline text-left list-reset" v-if="[12,13,14,15,19,21,22,24,26,27,28,29].includes(question.response_type)">
          <li v-if="question.response && question.response.validations && question.response.validations.length>0" v-for="(v,index) in question.response.validations" :key="index">
            <span > {{v.lineName}} </span>
            {{ v.message  }}
          </li>
        </ul>
        <ul class="error-messages block sm:inline text-left list-reset" v-else>
          <li>{{errorMessage}}</li>
        </ul>
      </div>
      <div v-if="validationMessage" class="w-full text-red-dark rounded relative px-4 py-2" role="alert">
        <ul class="error-messages block sm:inline text-left list-reset">
          <li>{{validationMessage}}</li>
        </ul>
      </div>

      <div class="w-full text-red-dark rounded relative px-4 py-2" role="alert">
        <ul class="error-messages block sm:inline text-left list-reset" v-if="!errorMessage">
          <li v-if="question.tag == 'unique_identif' && customErrors.unique_identifError">
            {{customErrors.unique_identifError ? customErrors.unique_identifError : errorMessage}}
          </li>
          <li v-if="question.response_type == '15' && customErrors.tablePourcentageError">
            {{customErrors.tablePourcentageError ? customErrors.tablePourcentageError : errorMessage}}
          </li>
          <li v-if="question.tag == 'num_compte_banq' && customErrors.num_compte_banqError">
            {{customErrors.num_compte_banqError ? customErrors.num_compte_banqError : errorMessage}}
          </li>
        </ul>
      </div>

      <div v-if="question.response_type == '30'" class="w-full text-red-dark rounded relative px-4 py-2" role="alert">
       <ul>
          <li v-if="question.response && question.response.customErros && question.response.customErros.message">
            {{ question.response.customErros.message  }}
          </li>
        </ul>
      </div>

      <div class="w-full relative px-4 py-2" :class="{'lg:w-1/2 border-rr':!([12,13,14,15,19,22,24,26,27,28,29,30,33].includes(question.response_type)),'has-error':invalidfield,'border-bb':[12,13,14,15,19,22,24,26,27,28,29,30,33].includes(question.response_type)}">
  
      <div v-if="question.response_type == '1'">
        <sp-input theme="form" v-if="question.tag == 'code_label'" 
          :required="Boolean(question.required)" 
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value="question.response" 
          @input="checkLabelRef"
          :label="question.content" 
          :disabled="disabled">
        </sp-input>
        <sp-input theme="form" v-else-if="question.tag == 'juridique_name'" 
          :required="Boolean(question.required)" 
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value.sync="childLegalName"
          :label="question.content" 
          :disabled="disabled">
        </sp-input>
        <sp-input theme="form" v-else-if="question.tag == 'unique_identif'" 
          :required="Boolean(question.required)" 
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value.sync="childIdentifiant"
          :label="question.content" 
          :disabled="disabled">
        </sp-input>
        <sp-input theme="form" v-else-if="question.tag == 'code_postal'" 
          :required="Boolean(question.required)" 
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value.sync="childIdentifiant"
          :label="question.content" 
          :disabled="codePostal && (codePostal[1] && codePostal[0] == 'codePostal') ? true : disabled">
        </sp-input>
        <sp-input v-else 
          theme="form" 
          :required="Boolean(question.required)" 
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value="question.response"
          :label="question.content" 
          :disabled="disabled">
        </sp-input>
      </div>
      <sp-textarea v-else-if="question.response_type == '0'"  :maxWords="question.max_count" theme="form" v-model="response.content" :required="Boolean(question.required)" :name="'input' + question.sort_order" :id="'input' + question.sort_order" :label="question.content" :disabled="disabled"></sp-textarea>

      <div v-else-if="question.response_type == '2'">
        <div v-if="response.content.id && requestForm">
           <sp-dropzone theme="form"  :required="Boolean(question.required)" :id="'input' + question.sort_order" :label="question.content" :url="url" :vdropzonesuccess="dropzoneSuccess" :vdropzoneError="vdropzoneError" :vdropzone-removed-file="vdropzoneRemovedFile"
                       :vdropzoneProcessing="vdropzoneProcessing"  :response="response" :question="this.question.response" :disabled="disabled" :downloadFile ="true" :cinFile="response.content">
          </sp-dropzone>
        </div>
        <div v-else-if="question.tag == 'paysheet'">
          <div v-if="requestFormShow">
            <sp-dropzone  theme="form"  :required="Boolean(question.required)" :id="'input' + question.sort_order" :label="question.content" :url="url" :vdropzonesuccess="dropzoneSuccess" :vdropzoneError="vdropzoneError" :vdropzone-removed-file="vdropzoneRemovedFile"
                          :vdropzoneProcessing="vdropzoneProcessing" :response="response" :question="this.question.response" :disabled="disabled" :downloadFile ="true" :maxFiles="1" :addRemoveLinks="false">
            </sp-dropzone>
          </div>
          <div v-else>
            <sp-dropzone  theme="form"  :required="Boolean(question.required)" :id="'input' + question.sort_order" :label="question.content" :url="url" :vdropzonesuccess="dropzoneSuccess" :vdropzoneError="vdropzoneError" :vdropzone-removed-file="vdropzoneRemovedFile"
                          :vdropzoneProcessing="vdropzoneProcessing" :response="response" :question="this.question.response" :disabled="disabled" :downloadFile ="true" :maxFiles="1">
            </sp-dropzone>
           </div>
        </div>
        <div v-else>
          <div v-if="requestFormShow">
            <sp-dropzone  theme="form"  :required="Boolean(question.required)" :id="'input' + question.sort_order" :label="question.content" :url="url" :vdropzonesuccess="dropzoneSuccess" :vdropzoneError="vdropzoneError" :vdropzone-removed-file="vdropzoneRemovedFile"
                        :vdropzoneProcessing="vdropzoneProcessing" :response="response" :question="this.question.response" :disabled="disabled" :downloadFile ="true" :addRemoveLinks="false">
            </sp-dropzone>
          </div>
          <div v-else>
            <sp-dropzone v-if="question.tag == 'max_excel_upload' && formType == 'INVESTOR_GUARANTEE_FORM' " theme="form"  :required="Boolean(question.required)" :id="'input' + question.sort_order" :label="question.content" :url="url" :vdropzonesuccess="dropzoneSuccess" :vdropzoneError="vdropzoneError" :vdropzone-removed-file="vdropzoneRemovedFile"
                        :vdropzoneProcessing="vdropzoneProcessing" :response="response" :question="this.question.response" :disabled="disabled" :downloadFile ="true" :maxFiles="2" :isExcel="true" acceptedFiles="xlsx,xlsm,xltx,xltm,xls,xlt,xla,xlsx,csv">
            </sp-dropzone>
            <sp-dropzone v-else theme="form"  :required="Boolean(question.required)" :id="'input' + question.sort_order" :label="question.content" :url="url" :vdropzonesuccess="dropzoneSuccess" :vdropzoneError="vdropzoneError" :vdropzone-removed-file="vdropzoneRemovedFile"
                        :vdropzoneProcessing="vdropzoneProcessing" :response="response" :question="this.question.response" :disabled="disabled" :downloadFile ="true" >
            </sp-dropzone>
           </div>
        </div>
      </div>

      <sp-dropzone v-else-if="question.response_type == '3'" theme="form"  :required="Boolean(question.required)" :id="'input' + question.sort_order" :url="url" :label="question.content" :vdropzonesuccess="dropzoneSuccess" :vdropzoneError="vdropzoneError" type="1" :vdropzone-removed-file="vdropzoneRemovedFile"
        :vdropzoneProcessing="vdropzoneProcessing" :response="response" :question="this.question.response" :disabled="disabled" :isImage ="true" acceptedFiles="image/*">
      </sp-dropzone>

      <sp-dropzone v-else-if="question.response_type == '16'" theme="form"  :required="Boolean(question.required)" :id="'input' + question.sort_order" :url="url" :label="question.content" :vdropzonesuccess="dropzoneSuccess" :vdropzoneError="vdropzoneError" type="0" :vdropzone-removed-file="vdropzoneRemovedFile"
                   :vdropzoneProcessing="vdropzoneProcessing" :response="response" :question="this.question.response" :disabled="disabled" :isExcel="true" acceptedFiles="">
      </sp-dropzone>
  
      <sp-url v-else-if="question.response_type == '4'" theme="form" :url="response.content" @update="onYoutubeUpdate"  :required="Boolean(question.required)" :label="question.content" :disabled="disabled"></sp-url>
  
      <sp-youtube v-else-if="question.response_type == '5'"  theme="form" :url="response.content" @update="onYoutubeUpdate" :required="Boolean(question.required)" :label="question.content" :disabled="disabled"></sp-youtube>
    
      <div v-else-if="question.response_type == '7'" v-show="question.option[0].default!='2'">
        <div class="block mb-4 text-blue text-2sm mb-4">
          <span v-if="question.tag == 'montant-cotisation'" v-html="question.content + (this.liberationValue ? parseFloat('0.005') * parseFloat(this.liberationValue) + 'dt' : '')"></span>
          <span v-else v-html="question.content"></span>
          <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
        </div>
        <sp-checkbox theme="form" v-for="(op, index) in question.option"   :key="index" :modelValue="response.content" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" :value="op.value" :disabled="disabled" :readonly="disabled">{{ op.name }}</sp-checkbox>
      </div>
  
      <div v-else-if="question.response_type == '8'">
        <div class="block mb-4 text-blue text-2sm mb-4">
          <span v-html="question.content"></span>
          <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
        </div>
        <flat-picker v-model="response.content" :config="{ dateFormat: 'Y-m-d',minDate:this.FlatPicker_minDate,maxDate:this.FlatPicker_maxDate}" :disabled="disabled" class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight">
        </flat-picker>
      </div>

      <div v-else-if="question.response_type == '17'">
        <div class="block mb-4 text-blue text-2sm mb-4">
          <span v-html="question.content"></span>
          <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
        </div>
        <flat-picker v-model="response.content" :config="{ dateFormat: 'Y-m-d',minDate:this.FlatPicker_minDate,maxDate:this.FlatPicker_maxDate, mode: 'range'}" :disabled="disabled" class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight">
        </flat-picker>
      </div>
      <div v-if="formType=='DECLARATION_DE_REALISATION' || formType=='DECLARATION_DE_REALISATION levée de fonds'">
        <sp-input theme="form" v-if="question.response_type == '10' && question.tag == 'Numero_rne'" 
          :required="Boolean(question.required)" :max="question.max_count"  
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value="dataToPass" 
          :label="question.content" :disabled="true">
        </sp-input>
        <sp-input theme="form" v-if="question.response_type == '10' && question.tag != 'Numero_rne'" 
          :required="Boolean(question.required)" :max="question.max_count"  
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value="question.response" 
          :label="question.content" :disabled="disabled">
        </sp-input>
      </div>
      <div v-else>
        <sp-input theme="form" v-if="question.response_type == '10' && question.tag == 'participation-libérée'" 
          type="number" :required="Boolean(question.required)" :max="question.max_count"  
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value="question.response" 
          :label="question.content" :disabled="disabled"
          @input="emitLiberationValue">
        </sp-input>
        <sp-input theme="form" v-if="question.response_type == '10' && question.tag != 'participation-libérée'" 
          type="number" :required="Boolean(question.required)" :max="question.max_count"  
          :name="'input' + question.sort_order" 
          v-model="response.content" 
          :value="question.response" 
          :label="question.content" :disabled="disabled">
        </sp-input>
      </div>
      
      <sp-input theme="form" v-if="question.response_type == '32'" 
        type="text" :required="Boolean(question.required)"  
        :name="'input' + question.sort_order" 
        v-model="response.content" 
        :value="question.response"
        :label="question.content" :disabled="disabled">
      </sp-input>
      
      

    <div v-if="question.response_type == '6'">
        <div class="block mb-4 text-blue text-2sm mb-4">
          <span v-html="question.content"></span>
          <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
        </div>
        <sp-radio theme="form" v-model="response.content" v-for="(op, index) in question.option" :key="index" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" :value="op.value" :disabled="disabled" :readonly="disabled">{{ op.name }}</sp-radio>
    </div>
    <div v-else-if="question.response_type == '11'">
      <div class="block mb-4 text-blue text-2sm mb-4">
        <span v-html="question.content"></span>
        <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
      </div>
        <div v-if="requestForm">      
          <sp-select v-if="(formType=='INVESTOR_GUARANTEE_FORM' || formType=='INVESTOR_CALL_GUARANTEE_FORM') && ['gouvernorat_resid','delegation_residence'].includes(question.tag)" theme="form"  v-model="response.content" :selected="response.content" :options="change_options ? change_options : question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
          <sp-select v-else-if="question.tag == 'section'" theme="form" v-model="response.content" :selected="response.content" :options="change_options ? change_options : question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
          <sp-select v-else-if="question.tag == 'division'" @select="onDivisionSelected" v-on:option-selected="onDivisionSelected" theme="form" v-model="response.content" :selected="response.content" :options="change_options ? change_options : question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
          <sp-select v-else-if="question.tag == 'groupe'" @select="onGroupSelected" v-on:option-selected="onGroupSelected" theme="form" v-model="response.content" :selected="response.content" :options="change_options ? change_options : question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
          <sp-select v-else-if="question.tag == 'classe'" theme="form" v-model="response.content" :selected="response.content" :options="change_options ? change_options : question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
          <sp-select v-else theme="form"  v-model="response.content" :options="change_options ? change_options : question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
        </div>
        <div v-else-if="requestFormEdit || requestFormShow">
          <sp-select theme="form" v-if="(formType=='INVESTOR_GUARANTEE_FORM' || formType=='INVESTOR_CALL_GUARANTEE_FORM') && ['gouvernorat_resid','delegation_residence'].includes(question.tag)"
            v-model="response.content"  
            :selected="question.response.content" 
            :options="change_options ? change_options : question.option" 
            :change_options ="change_options" 
            :name="'input' + question.sort_order" 
            :id="'input' + question.sort_order + index" 
            placeholder="Sélectionnez option" 
            :disabled="disabled">
          </sp-select>
          <sp-select v-else theme="form" v-model="response.content"  :selected="question.response.content" :options="question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
        </div>
        <div v-else>
          <sp-select theme="form"  v-model="response.content" :selected="question.response.content" :options="question.option" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option"></sp-select>
        </div>
    </div>

    <div v-else-if="question.response_type == '31'">
      <div class="block mb-4 text-blue text-2sm mb-4">
        <span v-html="question.content"></span>
        <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
      </div>
      <div v-if="requestForm">          
        <sp-select v-if="question.tag == 'section'" theme="form" v-model="response.content"  :options="question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
        <sp-select v-else-if="question.tag == 'division'" @select="onDivisionSelected" v-on:option-selected="onDivisionSelected" theme="form" v-model="response.content"  :options="question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
        <sp-select v-else-if="question.tag == 'groupe'" @select="onGroupSelected" v-on:option-selected="onGroupSelected" theme="form" v-model="response.content"  :options="question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
        <sp-select v-else-if="question.tag == 'classe'" theme="form" v-model="response.content"  :options="question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
        <sp-select v-else theme="form" @select="onOptionSelected" v-on:option-selected="onOptionSelected" v-model="response.content"  :options="question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
      </div>
      <div v-else-if="requestFormEdit || requestFormShow">
        <sp-select theme="form" @select="onOptionSelected" v-on:option-selected="onOptionSelected" v-model="response.content"  :selected="question.response.content" :options="question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>        
      </div>
      <div v-else>
        <sp-select theme="form" @select="onOptionSelected" v-on:option-selected="onOptionSelected"  v-model="response.content" :selected="question.response.content" :options="question.option" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option"></sp-select>
      </div>
    </div>

    <div v-else-if="question.response_type == '18'">
      <div class="block mb-4 text-blue text-2sm mb-4">
        <span v-html="question.content"></span>
        <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
      </div>
        <sp-select :selected="question.response.content" @inner-data="getInnerSelectData" theme="form"  v-model="response.content"  :options="question.option" :change_options ="change_options" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option" :disabled="disabled"></sp-select>
    </div>
      <div v-if="requestForm">
        <sp-table v-if="question.response_type == '12'" type="1" v-model="response.content"  :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '13'" type="2" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '14'" type="3" v-model="response.content" :tag ="question.tag" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '15'" type="4" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '19'" type="5" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '22'" type="8" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '24'" type="10" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '26'" type="12" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '27'" type="13" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '28'" type="14" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '29'" type="15" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table-list v-else-if="question.response_type == '30'" type="16" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table-list>
        <sp-table v-else-if="question.response_type == '33'" type="17" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
      </div>
      <div v-else>
        <sp-table v-if="question.response_type == '12'" type="1" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '13'" type="2" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '14'" type="3" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '15'" type="4" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '19'" type="5" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '22'" type="8" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '24'" type="10" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '26'" type="12" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '27'" type="13" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '28'" type="14" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '29'" type="15" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table-list v-else-if="question.response_type == '30'" type="16" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table-list>
        <sp-table v-else-if="question.response_type == '33'" type="17" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>

      </div>

    </div>

    <sp-tips v-if="question.tips.length > 0" :tips="question.tips" class="w-full lg:w-1/2 px-4 py-2"></sp-tips>
  </div>
    <div class="w-full" v-if="(question.questions!= 'undefined' && question.questions instanceof Array) && question.questions.length>0">
      <div v-for="(q, index) in question.questions" :key="index">
        
        <div v-if="haveSubLevel"> 
              <hide-q-form-funding :requestForm="true" v-if="response.content==q.trigger_option || (response.content.length > 0 && response.content.includes(q.trigger_option))" :question="q" :showError="showError" :responses="responses" :disabled="disabled"  @update-disabled="updateDisabled">

              </hide-q-form-funding>
        </div>

      <div v-else>
        <div v-if="requestForm">
          <hide-q-form :requestForm="true" v-if="response.content==q.trigger_option || (response.content.length > 0 && response.content.includes(q.trigger_option))" :question="q" :showError="showError" :responses="responses" :disabled="disabled"  @update-disabled="updateDisabled"></hide-q-form>
        </div>
        <div v-else>
          <hide-q-form  v-if="response.content==q.trigger_option || (response.content.length > 0 && response.content.includes(q.trigger_option))" :question="q" :showError="showError" :responses="responses" :disabled="disabled"  @update-disabled="updateDisabled"></hide-q-form>
        </div>
      </div>


      </div>
    </div> 

  </div>
</template>

<style>
  .has-error input,
  .has-error textarea,
  .has-error .dropzone.vue-dropzone,
  .has-error .checkmark,
  .has-error .ui.fluid.dropdown {
    border-color: #a94442 !important;
    background-color: #fce4e4 !important;
}
      
  .border-bb:after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 2px;
    background-image: linear-gradient(to right, rgba(210, 216, 224, 0), rgba(210, 216, 224, 0.28), rgba(210, 216, 224, 0.78), rgba(210, 216, 224, 0));
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>

<script>
  import ApiService from "@/common/api.service";
  import {
    FETCH_ECOSYSTEM_LABEL_REFS
  } from "@/store/actions.type";
  import Input from "../spKit/Input.vue";
  import Textarea from "../spKit/Textarea.vue";
  import Checkbox from "../spKit/Checkbox.vue";
  import Radio from "../spKit/Radio.vue";
  import YoutubeVue from "../spKit/Youtube.vue";
  import DropZoneVue from "../spKit/DropZone.vue";
  import UrlVue from "../spKit/Url.vue";
  import Tips from "@/components/spKit/Tips.vue";
  import {
    API_URL
  } from "@/common/config";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  const uploadURL = API_URL + "/documents/upload";
  import {
    mapGetters,
    mapState
  } from "vuex";
  import HideQFormVue from "./HideQForm";
  import SelectVue from '../spKit/Select.vue';
  import TableVue from '../spKit/Table.vue';
  import TableListVue from '../spKit/Table-list.vue';
  import HideQFormSubLevel from "./HideQFormSubLevel";
  import { localityList } from "@/common/data";
  import { dynamicList } from "@/common/codePostalData";
  import CodePostalListVue from '../../components/spKit/code-postaux-list.vue';
  import {
    DELETE_FILE
  } from "@/store/actions.type";
  import store from "@/store";
  
  export default {
    name: "q-form",
    data() {
      return {
        selectedIdentif: '',
        change_options:null,
        url: uploadURL,
        response: {
          id: this.question.id,
          content: ""
        },
        invalidfield: false,
        errorMessage: "",
        show:true,
        delegation_data: localityList().data,
        delegation_data1: dynamicList().data,
        FlatPicker_minDate:null,
        FlatPicker_maxDate:null,
        haveSubLevel: false,
        labelRef: this.childLegalName,
        identif: this.childIdentifiant,
        labelData: null,
        validationMessage: '',
        company: {
          "legal_name": null,
          "tax_identification_number": null,
          "cnss_affiliation_number": null,
          "address": null,
          "governorate": null,
          "delegation": null,
          "codePostal": null,
          "locality": null,
          "phone": null,
          "email": null,
          "activity_domain": null,
          "sector": null,
          "first_level_activity": null,
          "second_level_activity": null,
          "three_level_activity": null,
          "four_level_activity": null,
          "effective_women": null,
          "effective_men": null,
          //"date_start": null,
          "situation": null,
          "gerant": null,
          "contact_fullname": null,
          "contact_quality": null,
          "contact_phone": null,
          "file_patente_id": null,
          "file_afiliation_cnss_id": null,
          //"benefit_support_cnss": null,
          "file_listing_employees_id": null
        },
        customErrors: {
          num_compte_banqError: null,
          uniqueIdentifError: '',
          tablePourcentageError: ''
        },
        selectedSection: null,
        selectedDivision: null,
        selectedGroup: null,
        relatedDivisions: [],
        selectedGroup: null,
        selectedClass: null,
      };
    },
    components: {
      "sp-input": Input,
      "sp-textarea": Textarea,
      "sp-checkbox": Checkbox,
      "sp-radio": Radio,
      "sp-dropzone": DropZoneVue,
      "sp-youtube": YoutubeVue,
      "sp-url": UrlVue,
      "flat-picker": flatPickr,
      "hide-q-form": HideQFormVue,
      "sp-tips": Tips,
      "sp-select": SelectVue,
      "sp-table": TableVue,
      "sp-table-list": TableListVue,
      "hide-q-form-funding": HideQFormSubLevel,
      "sp-code-postal-list": CodePostalListVue

    },
    props: {
      formType: String,
      dataToPass: {
        type: Number|String,
        required: false,
      },
      childIdentifiant: {
        type: String,
        required: false,
      },
      childLegalName: {
        type: String,
        required: false,
      },
      index: Number,
      question: {
        required: true,
        type: Object,
        default: null
      },
      responses: {
        required: true,
        type: Array,
        default: null
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false
      },
      showError:{
        required: false,
        type: Boolean,
        default: false
      },
      started:{
        required: false,
        type: Boolean,
        default: false
      },
      requestForm:{
        required:false,
        type: Boolean,
        default: false
      },
      requestFormEdit:{
          required:false,
          type: Boolean,
          default: false
      },
      requestFormShow:{
          required:false,
          type: Boolean,
          default: false
      },
      delegation:{
          required:false,
          type: Array,
          default: null
      },
      codePostal:{
          required:false,
          type: Array,
          default: null
      },
      inversedGovernerate:{
          required:false,
          type: Array,
          default: null
      },
      inversedDelegation:{
          required:false,
          type: Array,
          default: null
      },
      showTeam:{
          required:false,
          type: Boolean,
          default: null
      },
      labelDate:{
          required:false,
          type: String,
          default: null
      },
      startLeaveDate:{
          required:false,
          type: String,
          default: null
      },
      startBourseDate:{
          required:false,
          type: String,
          default: null
      },
      endBourseDate:{
          required:false,
          type: String,
          default: null
      },
      requestId:{
        required: false,
        type: Number,
        default: null
      },
      edit:{
          required:false,
          type: Boolean,
          default: false
      },
      sections:{
        required:false,
        type: Array,
        default: null
      },
      divisions:{
        required:false,
        type: Array,
        default: null
      },
      groups:{
        required:false,
        type: Array,
        default: null
      },
      classes:{
        required:false,
        type: Array,
        default: null
      },
      liberationValue:{
        required: false,
        type: String,
        default: null
      }
    },
    methods: {
      emitLiberationValue() {
        // Emit the input value to the parent component
        this.$emit('input-change', this.response.content);
      },
      // validateField(field){
      //   let validationRule = this.validationConfig[this.question.tag];
      //   if (validationRule) {
      //     let error = validationRule(this.question.response);
      //     if (error) {
      //       this.customErrors[this.question.tag + 'Error'] = error;
      //     } else {
      //       this.customErrors[this.question.tag + 'Error'] = null;
      //     }
      //   }
      // },
      editChange(val){
          console.log(val);
          this.$emit("edit-change",val);
      },
      editChangeDel(val){
          console.log(val);

          this.$emit("edit-change",val);
      },
      editChangeCodePostal(val){
          console.log(val);

          this.$emit("edit-change",val);
      },
      delegationChange(val) {
        console.log(val);
        switch (val[0]) {
          case 'governorate':
              this.company.governorate = val[1];
              this.company.delegation = null;
              break;
          case 'delegation':
              this.company.delegation = val[1]; 
              break;
          case 'codePostal':
              this.company.codePostal = val[1]; 
              break;
        }
      },
      checkLabelRef() {
        this.$store
        .dispatch(FETCH_ECOSYSTEM_LABEL_REFS, this.response.content)
          .then(response => {
            const data = response;
            if (data) {
              const SELF = this;
              SELF.identif = data.identifiant
              SELF.labelRef = data.legal_name;
              SELF.labelData = data;
              this.$emit('response-updated', this.identif);
              this.$emit('response-updated-labelRef', this.labelRef);
              this.$emit('label-data', this.labelData);
              this.validationMessage= '';
            }
          })
          .catch(error => {
            const SELF = this;
            SELF.identif='';
            SELF.labelRef= ''
            console.error(error);
            this.validationMessage = 'Code label invalide';
          });
      },
      onOptionSelected(option) {
        const SELF = this;
        SELF.selectedIdentif = option;
        this.$emit('data-emitted', this.selectedIdentif);
      },
      onDivisionSelected(option) {
        const SELF = this;
        SELF.selectedDivision = this.response.content;
        const division = this.divisions.find(div => div.value === SELF.selectedDivision);
        if (division) {
          this.relatedGroups = division.groups; // Reset selected division
          this.$emit("relatedGroups", this.relatedGroups);
        }
        this.$emit('selectedDivision', this.selectedDivision);
      },
      onGroupSelected(option) {
        const SELF = this;
        SELF.selectedGroup = this.response.content;
        const group = this.groups.find(group => group.value === SELF.selectedGroup);
        if (group) {
          this.relatedClasses = group.classes; // Reset selected division
          this.$emit("relatedClasses", this.relatedClasses);
        }
        this.$emit('selectedGroup', this.selectedGroup);
      },
      getInnerSelectData(data){
        let options = []
        if((data.inner_data).length){
          data.inner_data.forEach((e,k) => {
          options.push({
            name: e,
            value: k
          })
        })
        }
        this.response = {options: options, child_tags: data.child_tags}
      },
      updateDisabled(status) {
        this.$emit('update-disabled', status)
      },
      vdropzoneProcessing(file) {
        this.updateDisabled(true);
      },
      dropzoneSuccess(file, response) {
        if (!(this.response.content instanceof Array)) {
          this.response.content = [];
        }
        if(response)this.response.content.push(response.data.document.id);
        this.responses[this.index] = this.response;
        this.updateDisabled(false);
      },
      vdropzoneError(file, message) {
        this.updateDisabled(false);
        if (message.meta && message.meta.status == 400) this.response.content.splice(-1, 1);
        this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
          "you cant upload this file";
  
      },
      vdropzoneRemovedFile(file, error, xhr) {
        if (typeof file.xhrt !== "undefined") {
          let data = JSON.parse(file.xhr.response);
          if (data.meta.status == 200) {
            let index = this.response.content.indexOf(data.data.document.id);
            if (index > -1) {
              this.response.content.splice(index, 1);
            }
          }
        } else {
          let index = this.response.content
            .map(function(x) {
              return x;
            })
            .indexOf(file.id);
          if (index > -1) {
            this.response.content.splice(index, 1);
          }
        }
      },
      onYoutubeUpdate(newUrl) {
        this.response.content = newUrl;
      },
      liberationDateRange: function () {
        var currentDate = new Date();
        this.FlatPicker_maxDate = currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth()+1)).slice(-2) + '-' + ('0' + currentDate.getDate()).slice(-2);
      },
      DateRange: function () {
        var currentDate = new Date();
        var currentDay  = currentDate.getDate();
        var labelDate   = new Date(this.labelDate);
        var minDate;
        var maxDate;
        var DateValue;
        if(this.question.response) {
            DateValue = this.question.response.content;
        }
        var FlatPicker_minDate;

        if(currentDay < 15){
            minDate = currentDate;
        }else{
            minDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
        }
        maxDate =  new Date(labelDate.setMonth(labelDate.getMonth()+6));
        FlatPicker_minDate = minDate.getFullYear() + '-' + (('0' + (minDate.getMonth()+1)).slice(-2)) + '-' + ('0' + minDate.getDate()).slice(-2);

        this.FlatPicker_minDate =  FlatPicker_minDate;
        this.FlatPicker_maxDate = maxDate.getFullYear() + '-' + (('0' + (maxDate.getMonth()+1)).slice(-2)) + '-' + ('0' + maxDate.getDate()).slice(-2);
      },
      extendLeaveDate() { 
        var startExtendDate = new Date(this.startLeaveDate);
        startExtendDate.setFullYear(startExtendDate.getFullYear() + 1);
        startExtendDate.setDate(startExtendDate.getDate() + 1);

        let endExtendDate = new Date(this.startLeaveDate);
        endExtendDate.setFullYear(endExtendDate.getFullYear() + 2);
        this.FlatPicker_minDate = startExtendDate.getFullYear() + '-' + (('0' + (startExtendDate.getMonth()+1)).slice(-2)) + '-' + ('0' + startExtendDate.getDate()).slice(-2);
        this.FlatPicker_maxDate = endExtendDate.getFullYear() + '-' + (('0' + (endExtendDate.getMonth()+1)).slice(-2)) + '-' + ('0' + endExtendDate.getDate()).slice(-2);
      },
      stopBourseDate() {
        let startStopBourse = new Date(this.startBourseDate);
        let endBourseDate = new Date(this.endBourseDate);
        this.FlatPicker_minDate = startStopBourse.getFullYear() + '-' + (('0' + (startStopBourse.getMonth()+1)).slice(-2)) + '-' + ('0' + startStopBourse.getDate()).slice(-2);
        this.FlatPicker_maxDate = endBourseDate.getFullYear() + '-' + (('0' + (endBourseDate.getMonth()+1)).slice(-2)) + '-' + ('0' + endBourseDate.getDate()).slice(-2);
      },
      async deleteFile(questionId, documentId, requestId) {
        await this.$store
          .dispatch(DELETE_FILE, {
            questionId: questionId,
            documentId: documentId,
            requestId: requestId
          }
        )
      }
    },
    created() {
      if (
        this.question.response != null &&
        this.question.response.content != null &&
        this.question.response.content != ""
      ) {
        this.response = {
          id: this.question.id,
          content: this.question.response.content
        };
      }
      if (
        this.question.response_type == "2" ||
        this.question.response_type == "3" ||
        this.question.response_type == "16"
      ) {
        this.response.content = [];
      }
      if (this.question.response_type == "7") {
        if(this.question.option[0].default=="2") {this.show=false;}
        if (this.question.response == null || this.question.response.content == null || this.question.response.content == "") {
          this.response.content = [];
          let CheckboxOption = this.question.option;
          if (
            typeof CheckboxOption !== "undefined" &&
            CheckboxOption.length > 0
          ) {
            Array.prototype.forEach.call(CheckboxOption, option => {
              if (option.default=="2" || option.default=="1") this.response.content.push(option.value);
            });
          }
        } else {
          this.response.content == this.question.response.content;
        }
      }
      if (this.question.response_type == "17") {
        this.response.content = this.response.content.split(",");
      }
      this.responses.push(this.response);
    },
    mounted() {
      // check if this Qform contains sub-level for his HideQForm
      if(this.question.questions.length){
        for (var i = 0; i < this.question.questions.length; i++) {
             if (this.question.questions[i].questions.length){
               this.haveSubLevel = true
               break;
             }
        }
      }
     
      if (
        this.question.response &&
        this.question.response.validations!=null &&
        this.question.response.validations.length > 0 &&
        this.started
      ) {
        this.invalidfield = true;
        this.errorMessage = this.question.response.validations[0]["message"];
      } else {
        this.invalidfield = false;
        this.errorMessage = "";
      }
      if(this.question.tag == 'liberation_date'){
          this.liberationDateRange()
      }
      if(this.question.tag == 'bourse_start_date' && (this.requestForm == true|| this.requestFormEdit == true)){
          this.DateRange()
      }
      if (this.question.tag == 'extend_leave_date'&& (this.requestForm == true|| this.requestFormEdit == true)){
        this.extendLeaveDate(); 
      }
      if (this.question.tag == 'stop_bourse_date'&& (this.requestForm == true|| this.requestFormEdit == true)) {
        this.stopBourseDate();
      }

    },
    computed: {
      ...mapState({
        errors: state => state.session.errors,
      }),
      ...mapGetters([
        "currentUser"
      ]),
      computedFormType() {
        return this.formType;
      }
    },
    watch: {
      dataToPass: function(newVal, oldVal) {
      // console.log(`propValue changed from ${oldVal} to ${newVal}`);
      },
      childIdentifiant: function(newVal) {
        if (this.question.response_type == '1' && this.question.tag=='unique_identif') 
        this.response.content = newVal;
      },
      childLegalName: function(newVal) {
          if (this.question.response_type == '1' && this.question.tag=='juridique_name')
        this.response.content = newVal;
      },
      codePostal: function(newVal) {
        if (this.question.response_type == '1' && this.question.tag=='code_postal')
        this.response.content = newVal;
      },
      inversedGovernerate: function(newVal) {
        if (this.question.response_type == '11' && (this.question.tag == "gouvernorat_naiss" ||this.question.tag == "gouvernorat_resid" ))
        this.response.content = newVal[1];
      },
      inversedDelegation: function(newVal) {
        if (this.question.response_type == '11' && (this.question.tag == "delegation_residence"))
        this.response.content = newVal[1];
      },
      selectedSection(newValue) {
        if (newValue) {
          const section = this.sections.find(sec => sec.value === newValue);
          if (section) {
            this.relatedDivisions = section.divisions; // Reset selected division
            this.$emit("relatedDivisions", this.relatedDivisions);
          }
        }else {
          this.relatedDivisions = []; // Reset relatedDivisions when no section is selected
        }
      },
      response:{

        handler(val){
          if (this.question.response_type == '1' && this.question.tag=='unique_identif') {
            if(this.childIdentifiant) {
              this.response.content = this.childIdentifiant;
              this.question.response = this.childIdentifiant;
            }
            this.customErrors.unique_identifError = '';
          }
          if (this.question.response_type == '1' && this.question.tag=='juridique_name' && !this.requestFormShow) {
              if(this.childLegalName) {
                this.response.content = this.childLegalName;
                this.question.response = this.childLegalName;
              }
          }
          if (this.question.response_type == '10' && this.question.tag == 'num_compte_banq' && !this.requestFormShow) {

          }
          if (this.question.response_type == '15' && this.question.tag == 'structure_capitale' && !this.requestFormShow) {
            


          }
          if (this.question.response_type == '1' && this.question.tag=='code_postal') {
            if (this.question.response) {
              const postalCode = parseInt(this.response.content, 10);
              const lists = dynamicList();
              if (!isNaN(postalCode)) {
                let delegation = null;
                let governorate = null;

                for (const governorateName in lists.data) {
                  const delegations = lists.data[governorateName];
                  for (const delegationName in delegations) {
                    if (delegations[delegationName][0] === postalCode) {
                      delegation = delegationName;
                      governorate = governorateName;
                      this.$emit("inversedDelegation", ["inversedDelegation", delegation]);
                      this.$emit("inversedGovernerate", ["inversedGovernerate", governorate]);
                      break;
                    }
                  }
                  if (delegation) {
                    break;
                  }
                }

                this.emittedDelegation = delegation;
                this.emittedGovernorate = governorate;
              } else {
                this.emittedDelegation = null;
                this.emittedGovernorate = null;
              }
            }
              if(this.codePostal) {
                const lists = dynamicList();
                const key = this.codePostal[1]; // Extract the key from the list

                let value = null;
                for (const dataKey in lists.data) {
                  if (Object.prototype.hasOwnProperty.call(lists.data, dataKey)) {
                    const innerData = lists.data[dataKey];
                    if (Object.prototype.hasOwnProperty.call(innerData, key)) {
                      value = innerData[key][0];
                      break;
                    }
                  }
                }
                this.response.content =value;
                this.question.response =value;
              }
          }
          if(this.question.response_type == '18') {
                this.$emit("governorate", ["governorate", val]);
            }
          
          if(this.question.response_type == '6' && (this.question.questions!= 'undefined' && this.question.questions instanceof Array) && this.question.questions.length>0){
              
             this.question.questions.forEach(q => {
                if(this.response.content!=q.trigger_option){
                  let index =  this.responses.map(function(x) {return x.id;}).indexOf(q.id);
                   if (index > -1) {
                      this.responses.splice(index, 1);
                      if (q.response.content && q.response.content.length > 0) {
                        this.deleteFile(q.id, q.response.content[0].id, this.requestId);
                        q.response.content = [];
                      }
                    }                 
                }
              });
          }
          if(this.question.response_type == '11' && (this.question.tag == "gouvernorat_naiss" ||this.question.tag == "gouvernorat_resid" ) ) {
            this.$emit("governorate", ["governorate", val]);
          }
          if(this.question.response_type == '11' && (this.question.tag == "delegation_residence" ) ) {
            this.$emit("delegation", ["delegation", val]);
            this.$emit("codePostal", ["codePostal", this.response.content]);
          }
          if(this.question.tag == "section" && 11 == this.question.response_type && !this.requestFormShow) {
            this.selectedSection = this.response.content;
          }
        },
        deep: true
      },
      delegation: function(val){
        if(val[1].child_tags && val[1].child_tags.includes(this.question.tag)){
          this.change_options = val[1].options
        }
        if((this.question.tag == "delegation_naissance") || (this.question.tag == "delegation_residence") ){
          if(val[1].content) {
            let d = val[1].content;
            const delegationData = this.delegation_data1[d];
            let i = 0;
            let option = [];
            for (const delegation in delegationData) {
              if (delegationData.hasOwnProperty(delegation)) {
                option.push({ name: delegation, value: delegation });
              }
            }
            this.change_options = option;
          } else {
            if(val[1])
            this.response.content = val[1];
          }
        }
      },
      divisions: function(val) {
        if(this.question.tag == "division" && 11 == this.question.response_type && !this.requestFormShow) {
          let newArray = [];
          newArray = this.divisions.filter(obj1 =>
            this.question.option.some(obj2 => obj1.name === obj2.name)
          );
          this.change_options = newArray;
        }
      },
      groups: function(val) {
        if(this.question.tag == "groupe" && 11 == this.question.response_type && !this.requestFormShow) {
          let newArray = [];
          newArray = this.groups.filter(obj1 =>
            this.question.option.some(obj2 => obj1.name === obj2.name)
          );
          this.change_options = newArray;
        }
      },
      classes: function(val) {
        if(this.question.tag == "classe" && 11 == this.question.response_type && !this.requestFormShow) {
          let newArray = [];
          newArray = this.classes.filter(obj1 =>
            this.question.option.some(obj2 => obj1.name === obj2.name)
          );
          this.change_options = newArray;
        }
      },
      question: function(val) {
          if((this.question.tag == "team_cin_number")||(this.question.tag == "team_firstname")||(this.question.tag == "team_lastname")){
              if( this.question.response.content){
                  this.response.content = this.question.response.content ;
              }
          }
        if (
          this.question.response &&
          this.question.response.validations!=null &&
          val.response.validations.length > 0 &&
          this.started
        ) {
          this.invalidfield = true;
          this.errorMessage = val.response.validations[0]["message"];
        } else {
          this.invalidfield = false;
          this.errorMessage = "";
        }
        if (this.question.response_type == "7") {
          if (this.question.response == null || this.question.response.content == null || this.question.response.content == "") {
            this.response.content = [];
          } 
          else {

            this.response.content == this.question.response.content;
          }
          
        }
        if (this.question.response_type == '10' && this.question.tag == 'Numero_rne') {
            if(this.dataToPass) {
              this.question.response = this.dataToPass;
              this.response.content = this.dataToPass;
            }
        }
      },
      started(){
               if (
                this.question.response &&
                this.question.response.validations!=null &&
                this.question.response.validations.length > 0 && 
                this.started
              ) {
                this.invalidfield = true;
                this.errorMessage = this.question.response.validations[0]["message"];
              } else {
                this.invalidfield = false;
                this.errorMessage = "";
              }
          
      }
      
     
    }
  };
</script>
